import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography } from '@mui/material';

const LoadingAnimation = ({ text = 'Loading...' }) => {
  const containerVariants = {
    animate: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const dotVariants = {
    initial: { y: 0 },
    animate: {
      y: [0, -15, 0],
      transition: {
        duration: 0.6,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
  };

  const colors = ['#6C63FF', '#FF6584', '#4ECDC4', '#FF9F1C', '#F15BB5'];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        py: 8,
      }}
    >
      <motion.div
        variants={containerVariants}
        initial="initial"
        animate="animate"
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
          marginBottom: '20px',
        }}
      >
        {colors.map((color, index) => (
          <motion.div
            key={index}
            variants={dotVariants}
            style={{
              width: '15px',
              height: '15px',
              borderRadius: '50%',
              backgroundColor: color,
            }}
          />
        ))}
      </motion.div>
      <Typography
        variant="h6"
        component="div"
        sx={{
          background: 'linear-gradient(45deg, #6C63FF 30%, #FF6584 90%)',
          backgroundClip: 'text',
          textFillColor: 'transparent',
          fontWeight: 600,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default LoadingAnimation; 